import React, { useEffect, Suspense } from "react";
import { observer } from "mobx-react";

import useConstants from "@hooks/useConstants";
import useError from "@hooks/useError";
import useStores from "@hooks/useStores";
import useStyles from "@hooks/useStyles";

import WebsiteHeader from "./WebsiteHeader";
import WebsiteBanner from "./WebsiteBanner";
import WebsiteAbout from "./WebsiteAbout";
import WebsiteWidget from "./WebsiteWidget";
import WebsiteReviews from "./WebsiteReviews";
import WebsiteServiceAreas from "./WebsiteServiceAreas";
import WebsiteChecklist from "./WebsiteChecklist";
import WebsiteFAQ from "./WebsiteFAQ";
import WebsiteGallery from "./WebsiteGallery";
import WebsiteLocationHours from "./WebsiteLocationHours";
import WebsiteCardList from "./WebsiteCardList";

import WebsiteMediaColumns from "./WebsiteMediaColumns";
import WebsiteCardColumns from "./WebsiteCardColumns";
import WebsiteServicesClasses from "./WebsiteServicesClasses";
import WebsiteCardSteps from "./WebsiteCardSteps";
import WebsiteFooter from "./WebsiteFooter";
import WebsiteSlider from "./WebsiteSlider";
import WebsiteEmbedCode from "./WebsiteEmbedCode";
import WebsiteGalleryInstagram from "./WebsiteGalleryInstagram";
import WebsitePDF from "./WebsitePDF";
import WebsiteLogoList from "./WebsiteLogoList";
import WebsiteQuote from "./WebsiteQuote";

const Website = () => {
	const classes = useStyles("Website");

	const showWidget = true;
	const showSlider = false;

	return (
		<>
			<div className={classes.body}>
				<WebsiteHeader />

				<WebsiteBanner />

				<WebsiteLogoList />

				<WebsiteCardColumns />

				<WebsiteAbout />

				<WebsiteServicesClasses />

				<WebsitePDF />

				<WebsiteMediaColumns />

				<WebsiteCardSteps />

				<WebsiteReviews />

				<WebsiteServiceAreas />

				<WebsiteCardList />

				<WebsiteChecklist />

				<WebsiteFAQ />

				<WebsiteQuote />

				<WebsiteGallery />

				<WebsiteGalleryInstagram />

				<WebsiteLocationHours />

				<WebsiteEmbedCode />

				<WebsiteFooter />

				{showWidget && <WebsiteWidget />}

				{showSlider && <WebsiteSlider />}
			</div>
		</>
	);
};

export default Website;
